import { Instagram } from "lucide-react";
import Logo from "@/components/Logo";

export const INSTAGRAM_URL = "https://www.instagram.com/matteo_caravetta_fisio";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-pine text-bone border-t border-bone/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <Logo light />
        <div className="text-xs text-bone/50 leading-relaxed">
          <p>Dott. Matteo Caravetta — Fisioterapista · P.IVA IT12985380018</p>
          <p className="mt-1">© 2026 Fisioterapia Dott. Caravetta Matteo. Tutti i diritti riservati.</p>
        </div>
        <div className="flex items-center gap-6">
          <a
            data-testid="footer-instagram-link"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-bone/50 hover:text-terracotta transition-colors duration-300"
          >
            <Instagram size={16} strokeWidth={1.5} /> Instagram
          </a>
          <a
            data-testid="footer-privacy-link"
            href="/privacy"
            className="text-xs uppercase tracking-[0.18em] text-bone/50 hover:text-terracotta transition-colors duration-300"
          >
            Privacy
          </a>
          <a
            data-testid="footer-admin-link"
            href="/admin/login"
            className="text-xs uppercase tracking-[0.18em] text-bone/50 hover:text-terracotta transition-colors duration-300"
          >
            Area riservata
          </a>
        </div>
      </div>
    </footer>
  );
}
